(() => {
  angular
    .module('app')
    .controller('host.views.postHospitalizationGuaranteeLetters.details.query.viewQuery', [
      '$scope',
      '$stateParams',
      'abp.services.app.serviceRequestQuery',
      controller,
    ]);

  function controller($scope, $stateParams, serviceRequestQuerySvc) {
    const vm = this;

    vm.loading = 0;
    vm.saving = 0;
    vm.guaranteeLetterNumber = $stateParams.letterNumber;
    vm.queryNumber = $stateParams.queryNumber;
    vm.claimNumber = $stateParams.claimNumber;
    vm.timeZoneId = $stateParams.timeZoneId;

    vm.resolve = resolve;
    vm.getDateTimeString = getDateTimeString;

    init();

    /* Functions */

    function getQuery() {
      vm.loading += 1;
      serviceRequestQuerySvc
        .getQuery({ id: vm.queryNumber })
        .success((data) => {
          vm.query = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function resolve() {
      vm.loading += 1;

      serviceRequestQuerySvc
        .resolveQuery({ id: vm.query.id, attachments: vm.query.repliedAttachments })
        .success(() => {
          abp.notify.success(App.localize('SuccessfullySaved'));
          getQuery();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getDateTimeString(date, timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }

    function init() {
      getQuery();
    }
  }
})();
